module.exports = __webpack_public_path__ + "img/foto condell 3.f8da5068.jpg";